import React from "react";

import InputValue from "./input_value";

import {
  WorkflowTask,
  ActionDefinition,
} from "common/flowmaster/types/task_config";
import {ChildDataLocation} from "common/flowmaster/types/data_location";
import {
  WorkflowContext,
  WorkflowInputs,
  WorkflowInput,
  WorkflowInputId,
  Prompt,
} from "common/flowmaster/types/workflow";
import {OrganisationId} from "common/types/organisation";

interface TextMapEditorProps {
  workflowInputs: WorkflowInput[];
  values: Record<WorkflowInputId, ChildDataLocation<string>>;
  onUpdateItem: (
    inputId: WorkflowInputId,
    value: ChildDataLocation<string>,
  ) => void;
  priorTasks: WorkflowTask[];
  context: WorkflowContext;
  inputs: WorkflowInputs;
  prompts: Prompt[];
  actionDefinitions: ActionDefinition[];
  organisationId: OrganisationId;
  useListItem: boolean;
  disabled?: boolean;
}

const TextMapEditor: React.FC<TextMapEditorProps> = ({
  workflowInputs,
  values,
  onUpdateItem,
  priorTasks,
  context,
  inputs,
  prompts,
  actionDefinitions,
  organisationId,
  useListItem,
  disabled = false,
}) => {
  return (
    <div>
      {workflowInputs.map(input => {
        return (
          <InputValue
            key={input.id}
            input={input}
            value={values[input.id]}
            onUpdateItem={(value: ChildDataLocation<string>) =>
              onUpdateItem(input.id, value)
            }
            priorTasks={priorTasks}
            context={context}
            inputs={inputs}
            prompts={prompts}
            actionDefinitions={actionDefinitions}
            organisationId={organisationId}
            useListItem={useListItem}
            disabled={disabled}
          />
        );
      })}
    </div>
  );
};

export default TextMapEditor;
